export const FINANCIAL_AID_STAFF_CORRECTION_PROTECTED_PATHS = [
  'additionalInfo.staffCorrections',
  'additionalInfo.staffInternalNotes',
  'additionalInfo.inviteEntrySource',
  'additionalInfo.parentCollectedFinancialAidSnapshot.version',
  'additionalInfo.parentCollectedFinancialAidSnapshot.signatures',
  'documentChecklist',
  'certification',
  'reviewSummary',
] as const;

export const FINANCIAL_AID_STAFF_CORRECTION_PROTECTED_SEGMENTS = [
  'id',
  'applicationId',
  'childApplicationId',
  'accountNumber',
  'socialSecurityLast4',
  'ssn',
  'ssnLast4OnFile',
  'socialSecurityNumber',
  'taxId',
  'driverLicense',
  'driverLicenseNumber',
] as const;

const protectedCorrectionSegments = new Set<string>(FINANCIAL_AID_STAFF_CORRECTION_PROTECTED_SEGMENTS);

const FINANCIAL_AID_STAFF_CORRECTION_ALLOWED_PARENT_SNAPSHOT_PATHS = new Set([
  'additionalInfo.parentCollectedFinancialAidSnapshot.savings.accountNumber',
  'additionalInfo.parentCollectedFinancialAidSnapshot.checking.accountNumber',
]);

export const isFinancialAidStaffCorrectionProtectedPath = (path: string): boolean =>
  (
    !FINANCIAL_AID_STAFF_CORRECTION_ALLOWED_PARENT_SNAPSHOT_PATHS.has(path)
    && path.split('.').some((segment) => protectedCorrectionSegments.has(segment))
  )
  || FINANCIAL_AID_STAFF_CORRECTION_PROTECTED_PATHS.some((protectedPath) =>
    path === protectedPath || path.startsWith(`${protectedPath}.`)
  );
